import variables from '@/styles/element-variables.scss'
import defaultSettings from '@/settings'
import { getsetting } from '@/api/setting'

const { showSettings, tagsView, fixedHeader, sidebarLogo } = defaultSettings

const state = {
  theme: variables.theme,
  showSettings: showSettings,
  tagsView: tagsView,
  fixedHeader: fixedHeader,
  sidebarLogo: sidebarLogo,
  HEP2Database: '',
  HEP2DBMark: ''
}

const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    // eslint-disable-next-line no-prototype-builtins
    if (state.hasOwnProperty(key)) {
      state[key] = value
    }
  }
}

const actions = {
  changeSetting({ commit }, data) {
    commit('CHANGE_SETTING', data)
  },
  getSettings({ commit }) {
    return new Promise((resolve, reject) => {
        getsetting().then(response => {
            for (let i = 0; i < response.data.length; i++) {
                commit('CHANGE_SETTING', { key: response.data[i].Name, value: response.data[i].Value })
            }
            resolve()
        }).catch(error => {
            reject(error)
        })
    })
}
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

